import React from "react";
import { WordCloud } from "@ant-design/charts";
import { Divider } from "antd";

const SearchCloud = (props) => {

    const {search_cloud = []} = props; 




    const data = search_cloud.map(item => {
        return {
            term : item.search_term,
            count : parseInt(item.count)
        }
    })


    const minValue = Math.min(...data.map(d => d.value));
    const maxValue = Math.max(...data.map(d => d.value));

   
    const getColor = (value) => {
        const intensity = 255 - Math.floor(((value - minValue) / (maxValue - minValue)) * 200);
        return `rgb(${intensity}, ${intensity}, ${intensity})`; // lighter gray for smaller values
    };


    const colours = ["#6895c7", "#6082a1", "#b0cc98", "#78b283", "#5b8363"]


   
    const config = {
        data,
        wordField: 'term',
        weightField: 'count',
        color: () => {
            return(colours[Math.floor(Math.random() * 5)])
        },
        wordStyle: {
            fontFamily: 'Verdana',
            fontSize: [10, 40], 
            rotation: [-3, 3],
        },
        random: 0.5, // Controls randomness in word placement
        width: 250,
        height: 400,
    };

    return (
        <div>
            <strong className="c" style={{ "fontSize": "13px" }}>Search Cloud</strong>
            <div style={{ "fontSize": "14px" }}><small>Popularity of search terms.</small></div>
            <Divider dashed style={{ "margin": "10px 0px" }} />

            <WordCloud {...config} />
        </div>

    );
};

export default SearchCloud;